import { SystemConfigApi } from '@/api';
import { defineStore } from 'pinia';

export const useVersionStore = defineStore({
    id: 'version',
    persist: true,
    state: () => ({
        releasedVersion: '' as string | undefined,
        systemApi: new SystemConfigApi(),
    }),
    getters: {
        updatedVersion: (state) =>
            !state?.releasedVersion ||
            state?.releasedVersion == import.meta.env.VITE_RELEASED_VERSION,
        sameVersion: (state) => state?.releasedVersion == import.meta.env.VITE_RELEASED_VERSION,
    },
    actions: {
        setReleasedVersion(version: string) {
            this.releasedVersion = version;
        },
        async getReleasedVersion() {
            if (this.sameVersion) return;
            return await this.systemApi.systemConfigReleasedVersion().then(async (response) => {
                if (response.data.success) {
                    this.setReleasedVersion(response.data.data ?? '');
                }
            });
        },
    },
});
